<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container" [dir]="dir" [ngClass]="{'minisidebar': minisidebar, 'boxed': boxed, 'danger': danger, 'blue': blue, 'green': green, 'horizontal' : horizontal }">

        <!-- ============================================================== -->
        <!-- Topbar - style you can find in header.scss -->
        <!-- ============================================================== -->
        <mat-toolbar color="primary" class="topbar relative">
            <div class="header">
                <!-- ============================================================== -->
                <!-- Logo - style you can find in header.scss -->
                <!-- ============================================================== -->
                
                <!-- ============================================================== -->
                <!-- sidebar toggle -->
                <!-- ============================================================== -->
                
                <img src="/assets/images/branding/Imagen1.png" class="img-logo"/>
                
                <button mat-icon-button (click)="snav.toggle()" class="sidebar-toggle"
                    value="sidebarclosed">
                    <mat-icon>menu</mat-icon>
                </button>
                <!-- ============================================================== -->
                <!-- Search - style you can find in header.scss -->
                <!-- ============================================================== -->
                <div class="search-container">
                    <button mat-icon-button class="srh-btn" (mouseenter)="showSearch = true" (click)="showSearch = !showSearch">
                        <mat-icon>search</mat-icon>
                    </button>
                    <form class="app-search" [ngClass]="{'show-search': showSearch}" >
                        <app-load-sidebar-modules *ngIf="showSearch"></app-load-sidebar-modules>
                    </form>
                </div>
                <span fxFlex></span>
                <p>{{userLogged?.Nickname || ''}}</p>
                <!-- ============================================================== -->
                <!-- app header component - style you can find in header.scss / header.component.ts-->
                <!-- ============================================================== -->
                <div *ngIf="!horizontal else horizontalheader">
                    <app-vertical-header></app-vertical-header>
                </div>

                <ng-template #horizontalheader>
                    <app-horizontal-header></app-horizontal-header>
                </ng-template>

                <!-- ============================================================== -->
                <!-- Right sidebar toggle - style you can find in rightsidebar.component.scss -->
                <!-- ============================================================== -->
                <button (click)="end.toggle()" mat-icon-button class="ml-xs overflow-visible">
                    <mat-icon>settings</mat-icon>
                </button>
            </div>

        </mat-toolbar>
        <!-- ============================================================== -->
        <!-- End Topbar - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
            [ngClass]="{'minisidebar': minisidebar}">
            <!-- ============================================================== -->
            <!-- Sidebar - style you can find in sidebar.scss -->
            <!-- ============================================================== -->
            <mat-sidenav #snav id="snav" class="pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0"
                [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true"
                (close)="sidebarOpened = false">

                <perfect-scrollbar *ngIf="!horizontal; else horizontalsidebar" class="scbar" [config]="config">
                    <app-vertical-sidebar class="app-sidebar" [showClass]='status' (notify)="snav.toggle()">
                    </app-vertical-sidebar>
                </perfect-scrollbar>

                <ng-template #horizontalsidebar>
                    <app-horizontal-sidebar></app-horizontal-sidebar>
                </ng-template>
            </mat-sidenav>

            <!-- ============================================================== -->
            <!-- Sidebar - style you can find in sidebar.scss -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- Right Sidebar - style you can find in rightsidebar.component.scss -->
            <!-- ============================================================== -->
            <mat-sidenav #end position="end" class="chat-panel" mode="over" opened="false">
                <div class="scroll">
                    <mat-nav-list>

                        <h3 mat-subheader class="text-uppercase font-weight-bold">Colors</h3>

                        <mat-list-item>
                            <mat-checkbox color="warn" [(ngModel)]="dark" (change)="darkClick()">Dark
                            </mat-checkbox>
                        </mat-list-item>
                    </mat-nav-list>
                </div>
            </mat-sidenav>

            <!-- ============================================================== -->
            <!-- Page container - style you can find in pages.scss -->
            <!-- ============================================================== -->
            <mat-sidenav-content class="page-wrapper" [ngClass]="status ? 'minitoggle' : ''">

                <app-breadcrumb></app-breadcrumb>
                <div class="page-content">
                    <router-outlet>
                        <app-spinner></app-spinner>
                    </router-outlet>

                </div>
            </mat-sidenav-content>
            <!-- ============================================================== -->
            <!-- Page container - style you can find in pages.scss -->
            <!-- ============================================================== -->
        </mat-sidenav-container>
    </div>